define(
    'viewmodels/secured/shares/sharedetails',[
        "viewmodels/ViewModel",
        "plugins/router",
        "viewmodels/secured/shares/context",
        "i19n!i19n/strings",

        // explicitely load these guys in up front to ensure any event handlers are attached and ready to receive.
        "viewmodels/secured/shares/tabs/documents/documents",
        "viewmodels/secured/shares/tabs/recipients/recipients"
    ],
    function (ViewModel, router, ctx, i19n, documents, recipients) {

        var documentsTabHtml = String.format("{0} <img class='spinner invisible' src='content/images/spinner.gif' />", i19n.to.documents);
        var recipientsTabHtml = String.format("{0} <img class='spinner invisible' src='content/images/spinner.gif' />", i19n.to.recipients);

        var vm = new ViewModel(
        {
            i19n: i19n,
            selectedTab: ko.observable(),
            tabs: {
                documents: new Tab(documentsTabHtml, "viewmodels/secured/shares/tabs/documents/documents"),
                recipients: new Tab(recipientsTabHtml, "viewmodels/secured/shares/tabs/recipients/recipients")
            },            
            subject: ko.observable(),
            expiryInfo: ko.observable(),
            id: ko.observable(""),
            title: ko.observable(""),
            subtitle: ko.observable(""),
        });

        vm.activate = function (mode) {
            vm.id(mode);

            documents.activate();
            recipients.activate();

            vm.subject(sessionStorage.getItem("documentsharedsubject"));
            vm.expiryInfo(sessionStorage.getItem("documentsharedexpiryinfo"));
            vm.title(mode == "my" ? i19n.to.mydocumentshares : i19n.to.alldocumentshares);
            vm.subtitle(mode == "my" ? i19n.to.mysharingofdocumentswith : i19n.to.allsharingofdocumentswith);
        };
        vm.close = function () {
            if (sessionStorage.__url) {
                window.location.href = sessionStorage.__url;
            } else {
                router.navigate("explorer");
            }
            //router.navigate("explorer");
        };
        vm.back = function () {
            router.navigate("shares/" + vm.id());
        };
        vm.activeTabs = ko.observableArray([
            vm.tabs.documents,
            vm.tabs.recipients
        ]);
        vm.tabSelected = function (tab) {
            return ko.asyncCommand({
                canExecute: function (isExecuting) {
                    return true;
                },
                execute: function (data, event, complete) {
                    vm.selectedTab(tab);

                    complete();
                }
            });
        };
        vm.selectedTab(vm.tabs.documents);        

        return vm;


        function Tab(label, module) {
            var self = this;

            self.label = ko.observable(label);
            self.module = ko.observable(module);
            self.data = ko.observable();
            self.disabled = ko.observable(true);
            self.isBusy = ko.observable(false);

            self.isBusy.subscribe(function (newValue) {
                self.label(newValue === true ? label.replace(" invisible", "") : label);
            });
        }
    });
